var chartColorChangeWeight = 50;
export function generateChartColor(chartColors, index) {
    var colorIndex = index % chartColors.length;
    var mainColor = chartColors[colorIndex];
    if (index === colorIndex) {
        return mainColor;
    }
    return {
        r: generateColorStrength(mainColor.r, chartColorChangeWeight),
        g: generateColorStrength(mainColor.g, chartColorChangeWeight),
        b: generateColorStrength(mainColor.b, chartColorChangeWeight),
    };
}
function generateColorStrength(themeColorStrength, changeWeight) {
    var minValue = themeColorStrength - changeWeight;
    var maxValue = themeColorStrength + changeWeight;
    if (minValue < 1) {
        minValue = 1;
    }
    if (maxValue > 255) {
        maxValue = 255;
    }
    return Math.floor(Math.random() * maxValue) + minValue;
}
export function getRgbaFromRgb(rgb, opacity) {
    if (!rgb || !rgb.r || !rgb.g || !rgb.b) {
        return '';
    }
    return "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + (opacity ? opacity : 1) + ")";
}
